<template>
  <div class="devices is-margin-top">

    <section>
      <div class='container'>

        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li class="is-active">
              <button id='refresh_button' class="button" @click='fetch_data()'>
                <b-icon icon="refresh"></b-icon>
              </button>
              <a href="#/tests" aria-current="page">&nbsp;&nbsp;Список Устройств</a>
            </li>
            </ul>
        </nav>
        
        <b-tabs v-model="activeTab" :animated='false'  type="is-toggle">

          <b-tab-item label="Клиенты">
            <div class="columns is-margin-top">
              <div class="column is-two-thirds"> 
                <b-table :data='clients' :selected.sync='selected_client' :loading='data_loading' paginated>
                  <template slot-scope="props">
                    <b-table-column field="room" label="Помещение" width="100" sortable>
                      {{ props.row.room }}
                    </b-table-column>
                    <b-table-column field="name" label="Название" width="100" sortable>
                      {{ props.row.name }}
                    </b-table-column>
                    <b-table-column field="level" label="Сложность" width="100" sortable>
                      {{ props.row.level }}
                    </b-table-column> 
                    <b-table-column field="name" label="Страница" width="100" sortable>
                      {{ props.row.current_page }}
                    </b-table-column>
                    <b-table-column field='status' label='Статус' width='100' sortable>
                      <span v-if='props.row.status === "online"' class="tag is-success">{{ props.row.status }}</span>
                      <span v-if='props.row.status === "offline"' class="tag is-danger">{{ props.row.status }}</span>
                    </b-table-column>
                    <b-table-column field="lastseen" label="Онлайн" width="100" sortable>
                      {{ new Date(props.row.lastseen).toLocaleString() }}
                    </b-table-column>
                  </template>
                </b-table>
              </div>
              <div class='column is-one-third'>
                <section class='is-margin-top box fast_edit'>
                  <b-tabs class="block" v-if='selected_client.hasOwnProperty("_id")' :animated='false'>
                    <b-tab-item label='Основные'>
                      
                      <b-field label="Название" class='is-margin-top'>
                        <b-input placeholder='Название' v-model='selected_client.name'></b-input>
                      </b-field>

                      <b-field label='Помещение' class='is-margin-top'>
                        <b-input placeholder='Помещение' v-model='selected_client.room'></b-input>
                      </b-field>

                      <b-field label='Сложность' class='is-margin-top'>
                        <b-input placeholder='Сложность' v-model='selected_client.level'></b-input>
                      </b-field>

                      <b-field label='Кол-во вопросов' class='is-margin-top'>
                        <b-input placeholder='Кол-во вопросов' v-model='selected_client.answers_needed'></b-input>
                      </b-field>

                      <b-field class='is-margin-top'>
                        <button class='button' @click='save_client()'>сохранить</button>
                      </b-field>

                    </b-tab-item>
                    <b-tab-item label='Действия'>
                     <b-field label='Действия'>
                        <b-select placeholder="Выберите действие" v-model='selected_client_action'>
                          <option v-for='action in client_actions' :value='action' :key='action.id'>{{ action.label }}</option>
                        </b-select>
                      </b-field>
                      <div class="notification" v-if='selected_client_action.hasOwnProperty("method")'>
                        <b-field v-if='selected_client_action.method === "login_as"' label='Пользователь'>
                          <b-input v-model='selected_client_action.params.username'></b-input>
                        </b-field>
                      </div>
                      <b-field>
                          <button class='button' @click='run_client_action()'>Выполнить</button>
                        </b-field>
                    </b-tab-item>
                  </b-tabs>
                  <div v-else class='is-margin-top notification'>
                    Выберите устройство для быстрого редактирования.
                  </div>
                </section>
              </div>
            </div>
          </b-tab-item>

          <b-tab-item label="Считыватели">
            <div class="columns is-margin-top">
              <div class="column is-two-thirds"> 
                <b-table :data='readers' :selected.sync='selected_client' :loading='data_loading' paginated>
                  <template slot-scope="props">
                    <b-table-column field="room" label="Помещение" width="100" sortable>
                      {{ props.row.room }}
                    </b-table-column>
                    <b-table-column field="name" label="Название" width="100" sortable>
                      {{ props.row.name }}
                    </b-table-column> 
                    <b-table-column field='status' label='Статус' width='100' sortable>
                      <span v-if='props.row.status === "online"' class="tag is-success">{{ props.row.status }}</span>
                      <span v-if='props.row.status === "offline"' class="tag is-danger">{{ props.row.status }}</span>
                    </b-table-column>
                    <b-table-column field="lastseen" label="Онлайн" width="100" sortable>
                      {{ new Date(props.row.lastseen).toLocaleString() }}
                    </b-table-column>
                  </template>
                </b-table>
              </div>
              <div class='column is-one-third'>
                <section class='is-margin-top box fast_edit'>
                  <b-tabs class="block" v-if='selected_client.hasOwnProperty("_id")' :animated='false'>
                    <b-tab-item label='Основные'>
                      
                      <b-field label="Название" class='is-margin-top'>
                        <b-input placeholder='Название' v-model='selected_client.name'></b-input>
                      </b-field>

                      <b-field label='Помещение' class='is-margin-top'>
                        <b-input placeholder='Помещение' v-model='selected_client.room'></b-input>
                      </b-field>

                      <b-field class='is-margin-top'>
                        <button class='button' @click='save_client()'>сохранить</button>
                      </b-field>

                    </b-tab-item>
                  </b-tabs>
                  <div v-else class='is-margin-top notification'>
                    Выберите устройство для быстрого редактирования.
                  </div>
                </section>
              </div>
            </div>
          </b-tab-item>

          <b-tab-item label="Админские">
            <div class="columns is-margin-top">
              <div class="column is-two-thirds"> 
                <b-table :data='admins' :selected.sync='selected_client' :loading='data_loading' paginated>
                  <template slot-scope="props">
                    <b-table-column field="room" label="Помещение" width="100" sortable>
                      {{ props.row.room }}
                    </b-table-column>
                    <b-table-column field="name" label="Название" width="100" sortable>
                      {{ props.row.name }}
                    </b-table-column>
                    <b-table-column field="name" label="Страница" width="100" sortable>
                      {{ props.row.current_page }}
                    </b-table-column>
                    <b-table-column field='status' label='Статус' width='100' sortable>
                      <span v-if='props.row.status === "online"' class="tag is-success">{{ props.row.status }}</span>
                      <span v-if='props.row.status === "offline"' class="tag is-danger">{{ props.row.status }}</span>
                    </b-table-column>
                    <b-table-column field="lastseen" label="Онлайн" width="100" sortable>
                      {{ new Date(props.row.lastseen).toLocaleString() }}
                    </b-table-column>
                  </template>
                </b-table>
              </div>
              <div class='column is-one-third'>
                <section class='is-margin-top box fast_edit'>
                  <b-tabs class="block" v-if='selected_client.hasOwnProperty("_id")' :animated='false'>
                    <b-tab-item label='Основные'>
                      
                      <b-field label="Название" class='is-margin-top'>
                        <b-input placeholder='Название' v-model='selected_client.name'></b-input>
                      </b-field>

                      <b-field label='Помещение' class='is-margin-top'>
                        <b-input placeholder='Помещение' v-model='selected_client.room'></b-input>
                      </b-field>

                      <b-field class='is-margin-top'>
                        <button class='button' @click='save_client()'>сохранить</button>
                      </b-field>

                    </b-tab-item>
                  </b-tabs>
                  <div v-else class='is-margin-top notification'>
                    Выберите устройство для быстрого редактирования.
                  </div>
                </section>
              </div>
            </div>
          </b-tab-item>

          <b-tab-item label="Автоматы">
            <div class="columns is-margin-top">
              <div class="column is-two-thirds"> 
                <b-table :data='vgms' :selected.sync='selected_client' :loading='data_loading' paginated>
                  <template slot-scope="props">
                    <!-- <b-table-column field="room" label="Помещение" width="100" sortable>
                      {{ props.row.room }}
                    </b-table-column> -->
                    <b-table-column field="name" label="Название" width="100" sortable>
                      {{ props.row.name }}
                    </b-table-column> 
                    <b-table-column field='status' label='Статус' width='100' sortable>
                      <span v-if='props.row.status === "online"' class="tag is-success">{{ props.row.status }}</span>
                      <span v-if='props.row.status === "offline"' class="tag is-danger">{{ props.row.status }}</span>
                    </b-table-column>
                    <b-table-column field="lastseen" label="Онлайн" width="100" sortable>
                      {{ new Date(props.row.lastseen).toLocaleString() }}
                    </b-table-column>
                  </template>
                </b-table>
              </div>
              <div class='column is-one-third'>
                <section class='is-margin-top box fast_edit'>
                  <b-tabs class="block" v-if='selected_client.hasOwnProperty("_id")' :animated='false'>
                    <b-tab-item label='Основные'>
                      
                      <b-field label="Название" class='is-margin-top'>
                        <b-input placeholder='Название' v-model='selected_client.name'></b-input>
                      </b-field>

                      <b-field label="Номер GPIO" class='is-margin-top'>
                        <b-input placeholder='Номер GPIO' v-model='selected_client.params.gpio'></b-input>
                      </b-field>

                      <b-field label="Время нажатия (мс)" class='is-margin-top'>
                        <b-input placeholder='Время нажатия (мс)' v-model='selected_client.params.press_by'></b-input>
                      </b-field>

                      <b-field label="Время аренды (с)" class='is-margin-top'>
                        <b-input placeholder='Время аренды (с)' v-model='selected_client.params.booked_by'></b-input>
                      </b-field>

                      <b-field label="Цена" class='is-margin-top'>
                        <b-input placeholder='Цена' v-model='selected_client.params.price'></b-input>
                      </b-field>

                      <!-- <b-field label='Помещение' class='is-margin-top'>
                        <b-input placeholder='Помещение' v-model='selected_client.room'></b-input>
                      </b-field> -->

                      <b-field class='is-margin-top'>
                        <button class='button' @click='save_client()'>сохранить</button>
                      </b-field>

                    </b-tab-item>
                  </b-tabs>
                  <div v-else class='is-margin-top notification'>
                    Выберите устройство для быстрого редактирования.
                  </div>
                </section>
              </div>
            </div>
          </b-tab-item>

        </b-tabs>

      </div>
    </section>

  </div>
</template>

<script>
  import store from '../store'
  export default {
    name: 'devices',
    data () {
      this.$parent.active_tab = 'devices'
      this.fetch_data()
      return {
        store: store,
        activeTab: 0,
        data_loading: false,
        clients: [],
        readers: [],
        admins: [],
        selected_client: {},
        selected_reader: {},
        client_actions: [
          // {id: 0, label: 'Выберите действие'},
          {},
          {id: 1, label: 'Выход с аккаунта', method: 'logout', params: {}},
          {id: 2, label: 'Залогинить', method: 'login_as', params: {username: ''}},
          {id: 3, label: 'Пинг', method: 'show_loading', params: {}},
          {id: 4, label: 'Перезапустить', method: 'reload_page', params: {}},
          {id: 105, label: 'Карта 1', method: 'reader_read', params: {card_number: '80000000001'}},
          {id: 106, label: 'Карта 2', method: 'reader_read', params: {card_number: '80000000002'}},
          {id: 107, label: 'Карта 3', method: 'reader_read', params: {card_number: '80000000003'}}
        ],
        selected_client_action: {},
        reader_actions: [],
        selected_reader_action: {}
      }
    },
    methods: {
      fetch_data: function () {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_get_devices', params: {}})
        window.$.post(window.gw + 'api/device', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.clients = d.params.clients
            t.readers = d.params.readers
            t.admins = d.params.admins
            t.vgms = d.params.vgms
            t.data_loading = false
          }
        })
        return
      },
      save_client: function () {
        var t = this
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_save_device', params: {device: t.selected_client}})
        window.$.post(window.gw + 'api/device', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.data_loading = false
          }
        })
        return
      },
      run_client_action: function () {
        var t = this
        console.log(t.selected_client_action)
        if (!t.selected_client_action.hasOwnProperty('method')) return
        if (t.selected_client_action.id > 100) {
          // store.commit('ws_send', t.selected_client_action)
          this.$socket.send(JSON.stringify(t.selected_client_action))
          return
        }
        t.data_loading = true
        var form = JSON.stringify({method: 'admin_run_action', params: {device: t.selected_client, action: t.selected_client_action}})
        window.$.post(window.gw + 'api/device', {data: form}, function (r) {
          var d = JSON.parse(r)
          if (d.result === 'ok') {
            t.data_loading = false
            t.selected_client_action = {}
          }
        })
        return
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Devices.vue